import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import DownArrowIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_arrow_down.svg';
import UpArrowIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_arrow_up.svg';
import css from './participation-improvement.scss';

/**
 * Displays improvement in student participation tables when comparing 2 results (eg. first vs highest)
 */
class ParticipationImprovement extends Component {
    static propTypes = {
        improvement: PropTypes.number
    };

    renderImprovement() {
        const { improvement } = this.props;
        const na = window.i18n._('Label - NA');
        switch (improvement) {
            case null:
            case undefined:
                return <div className={css['null-improvement']}>{na}</div>;
            case 0:
                return <div className={css.equal}>=</div>;
            default:
                return this.renderImprovementDifference(improvement);
        }
    }

    renderImprovementDifference = (difference) => {
        const isPositive = difference > 0;
        const icon = isPositive ? UpArrowIcon : DownArrowIcon;
        const className = isPositive ? css.positive : css.negative;

        return (
            <div className={className}>
                <Isvg
                    className={css['arrow-icon']}
                    src={icon}
                    cacheGetRequests
                />
                {Math.abs(difference)}%
            </div>
        );
    };

    render() {
        return <div className={css.component}>{this.renderImprovement()}</div>;
    }
}

export default styleable(css)(ParticipationImprovement);



// WEBPACK FOOTER //
// ./components/participation-improvement/participation-improvement.js